import React, { FC, useEffect, useState } from 'react';
import { Box, Dialog, TextField, DialogContent, DialogTitle } from '@material-ui/core';
import { BlueTickIcon, DialogCloseComponent, SearchIcon } from 'Components';
import classNames from 'classnames';
import { useLocalization } from 'Hooks';
import { turkishCharacterNormalize } from 'Utils';
import { useSelector } from 'react-redux';

import './DialogBuilding.scss';
import { AccountState, storeAccount, getApartmentListRequest } from 'Stores/Account';
import { useDispatch } from 'react-redux';
import { BuildingItemType } from 'Services/Queries/GetBuildingList';

type DialogBuildingProps = {
  hide: () => void;
  isOpen: boolean;
  selectedValue?: string;
  setSelectedValue: Function;
};

const DialogBuilding: FC<DialogBuildingProps> = ({ hide, isOpen, selectedValue, setSelectedValue }) => {
  const { web_account_search } = useLocalization();
  const [searchKey, setSearchKey] = useState<string>('');
  const dispatch = useDispatch();

  const lowerCaseSearchKey = searchKey.toLocaleLowerCase();

  const accountData: AccountState = useSelector(storeAccount);

  const buildings: BuildingItemType[] | undefined = accountData?.buildingList;

  const itemClickHandle = (buildingItem: BuildingItemType) => {
    setSelectedValue(buildingItem);
    dispatch(getApartmentListRequest(buildingItem.kayitNo.toString()));
    hide();
  };

  const onClose = () => {
    setSearchKey('');
    hide();
  };

  useEffect(() => {
    setSearchKey('');
  }, [hide]);

  return (
    <Dialog id="dialogBuilding" onClose={onClose} scroll="paper" keepMounted={false} open={isOpen}>
      <Box position="absolute" top={8} right={8} zIndex={2}>
        <DialogCloseComponent closeFunction={hide} />
      </Box>
      <DialogTitle className="dialogBuilding-search" style={{ paddingRight: 48 }}>
        <TextField
          label={web_account_search}
          variant="filled"
          value={searchKey}
          onChange={(e) => setSearchKey(e.currentTarget.value)}
          InputProps={{
            endAdornment: <SearchIcon />,
          }}
          fullWidth
        />
      </DialogTitle>

      <DialogContent>
        <div className="dialogBuilding-container">
          <JobBlock
            buildingItems={buildings}
            searchKey={searchKey}
            selectedValue={selectedValue}
            lowerCaseSearchKey={lowerCaseSearchKey}
            itemClickHandle={itemClickHandle}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

const JobBlock: FC<{
  buildingItems: BuildingItemType[] | undefined;
  searchKey: string;
  lowerCaseSearchKey: string;
  selectedValue?: string;
  itemClickHandle: Function;
}> = ({ buildingItems, lowerCaseSearchKey, selectedValue, itemClickHandle }) => {
  return (
    <ul className="dialogBuilding-container__list" role="listbox">
      {!!buildingItems &&
        buildingItems.length > 0 &&
        buildingItems
          .filter((item: BuildingItemType) => {
            return (
              !!item?.disKapiNo1 &&
              turkishCharacterNormalize(String(item?.disKapiNo1)).includes(
                turkishCharacterNormalize(lowerCaseSearchKey)
              )
            );
          })
          .map((item: BuildingItemType, index) => (
            <Item
              key={index}
              title={String(item.disKapiNo1)}
              isSelected={String(item.disKapiNo1).toLocaleLowerCase('tr-TR') === selectedValue}
              onClick={() => itemClickHandle(item)}
            />
          ))}
    </ul>
  );
};

const Item: FC<{
  title: string;
  onClick: Function;
  isSelected: boolean;
}> = ({ title, onClick, isSelected }) => {
  return (
    <li 
      onClick={() => onClick()} 
      role="option"
      tabIndex={0}
      onKeyDown={(e)=>{
        if(e.key ==='Enter' || e.key === ' '){
          e.preventDefault();
          onClick();
        }
      }}
      itemID="chooseAdressBuildingBtnTest">
      <div
        className={classNames({
          'dialogBuilding-container__list-item': true,
          'dialogBuilding-container__list-item--selected': isSelected,
        })}
      >
        <span className="input-text">{title.toLocaleLowerCase('tr-TR')}</span>
        {isSelected && <BlueTickIcon />}
      </div>
    </li>
  );
};

export default DialogBuilding;
